/**
 * Shared constants and value mappings for merchandiser lists (PD-13923).
 * Status values mirror the merchandiser entity enum (active/inactive/
 * maintenance/offline).
 */
export const MERCHANDISER_STATUS_VALUE_MAPPING = [
	{
		value: 'active',
		label: 'Active',
		color: { type: 'success' },
	},
	{
		value: 'inactive',
		label: 'Inactive',
		color: { type: 'neutral' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { type: 'warning' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { type: 'danger' },
	},
];
